import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import DataTable from "../components/UI/DataTable/DataTable";
// import { GUESTS_TABLE_ID, PARKERS_TABLE_ID } from "../config/Config";
import {
  GUSETS_TABLE_COLUMNS,
  PARKERS_TABLE_COLUMNS,
} from "../constants/Constants";
import ParkerDetails from "../containers/UserInfo/Details/ParkerDetails";
import History from "../containers/UserInfo/History/History";
import { SCOPE_TYPE, TABLES } from "../enums/Enums";
// import { parkersActions } from "../redux/reducers/ParkersReducer";
import store from "../redux/Store";
import { allocationsActions } from "../redux/reducers/AllocationsReducer";
import Strings from "../resources/Strings";

const useParkerService = () => {
  //const currentUsersSite = useSelector((state) => state.user.currentUsersSite);

  const currentUsersScopes = useSelector((state) => state.user.currentUsersScopes);
  const guests = useSelector((state) => state.user.guests);
  const parkers = useSelector((state) => state.user.parkers);
  const selectedScope = useSelector((state) => state.user?.selectedScope); // test


  // Handle delete of parking status column for parker table (occurs if selectedScope is not Project type)
  let isParkingStatusHideRequired = selectedScope && selectedScope?.type !== SCOPE_TYPE.PROJECT;

  let originalParkerColumns = [...PARKERS_TABLE_COLUMNS];
  let modifiedParkerColumns = [...PARKERS_TABLE_COLUMNS];

  let parkersColumns = isParkingStatusHideRequired ? modifiedParkerColumns : originalParkerColumns;
  let isParkerColumnExists = parkersColumns.some(c => c.headerName === Strings.PARKERS_COLUMNS_NAMES.PARKING);
  let indexParkerColumnToDelete = isParkingStatusHideRequired && PARKERS_TABLE_COLUMNS.findIndex(c => c.headerName === Strings.PARKERS_COLUMNS_NAMES.PARKING);
  
  // Handle delete of parking status column for guest table
  let originalGuestColumns = [...GUSETS_TABLE_COLUMNS];
  let modifiedGuestColumns = [...GUSETS_TABLE_COLUMNS];

  let guestsColumns = isParkingStatusHideRequired ? modifiedGuestColumns : originalGuestColumns;
  let isGuestColumnExists = guestsColumns.some(c => c.headerName === Strings.PARKERS_COLUMNS_NAMES.PARKING);
  let indexGuestColumnToDelete = isParkingStatusHideRequired && GUSETS_TABLE_COLUMNS.findIndex(c => c.headerName === Strings.PARKERS_COLUMNS_NAMES.PARKING);

  const selectedSite = useSelector((state) => state.user.selectedSite);
  const sites = useSelector((state) => state.user.sites);
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);

  // Handles column delete for parker table
  if (isParkingStatusHideRequired && isParkerColumnExists) {
    modifiedParkerColumns.splice(indexParkerColumnToDelete, 1);
  } 

  // Handles column delete for guest table
  if (isParkingStatusHideRequired && isGuestColumnExists) {
    modifiedGuestColumns.splice(indexGuestColumnToDelete, 1);
  }

  useEffect(() => {
    // when parker data arrives after the call, arranges the allocations data  
    if (parkers) {
      store.dispatch(allocationsActions.setAllocations({parkers, sites, userTypes}));
    }
  }, [parkers]);


  const getParkersDataTable = (eventFn) => {
    return ( selectedScope &&
      <DataTable
        onRowClick={eventFn.bind(this, TABLES.PARKERS)}
        columns={parkersColumns}
        rows={parkers}
        tableId={TABLES.PARKERS}
        selectedScope={selectedScope}
      ></DataTable>
    );
  };

  const getGuestsDataTable = (eventFn) => {
    return ( selectedScope &&
      <DataTable
        onRowClick={eventFn.bind(this, TABLES.GUESTS)}
        columns={guestsColumns}
        rows={guests}
        getRowId={(row) => row?.mainCarToken?.carUserTokens[0]?.id}
        tableId={TABLES.GUESTS}
        selectedScope={selectedScope} 
      ></DataTable>
    );
  };

  const getParkerHistory = (props) => {
    return <History {...props}></History>;
  };

  const getParkerDetails = (props) => {
    return <ParkerDetails {...props}></ParkerDetails>;
  };

  return {
    getParkersDataTable,
    getGuestsDataTable,
    getParkerHistory,
    getParkerDetails, 
  };
};

export default useParkerService;
